import { render } from "./SectionView.vue?vue&type=template&id=fffec07c"
import script from "./SectionView.vue?vue&type=script&lang=js"
export * from "./SectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__